import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { formatDate, formatDateOnly } from "../../../helper/Helper";
import webAPI from "../../../api/webApi";
import Auth from "../../../utils/AuthUtils";
import Pagination from "../../../layout/admin/partials/Pagination";

function List() {
  const role = Auth.getUserDetails("roles");

  const [items, setItems] = useState([]); // State for store list
  const [pagination, setPagination] = useState({}); // State for pagination info
  const [searchParams, setSearchParams] = useSearchParams();

  const [deleteId, setDeleteId] = useState(null);
  const [deleteTable, setDeleteTable] = useState(null);

  useEffect(() => {
    fetchParticipantData();
  }, [searchParams]);

  const fetchParticipantData = async () => {
    const page = parseInt(searchParams.get("page")) || 1;
    const limit = parseInt(searchParams.get("limit")) || 50;
    const search = searchParams.get("search") || null;

    const res = await webAPI.getList({
      page,
      limit,
      search,
    });
    if (res.code === 200) {
      setItems(res.data.items);
      setPagination(res.data.pagination);
    } else {
      setItems([]);
    }
  };

  const updateFilter = (key, value) => {
    const params = new URLSearchParams(searchParams);
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
    setSearchParams(params);
  };

  const handleOpenDeleteModal = (id, table) => {
    setDeleteId(id);
    setDeleteTable(table);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-flex align-items-center justify-content-between gap-2 mb-4 flex-wrap">
            <div>
              <h4 className="mb-1">
                Registered Participant
                <span className="badge badge-soft-primary ms-2">
                  {pagination?.total}
                </span>
              </h4>
              <h6 className="text-muted">
                View, search, and manage all registered participant available in
                your system.
              </h6>
            </div>
            <div className="gap-2 d-flex align-items-center flex-wrap">
              <button
                type="button"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#standard-modal"
              >
                <i className="ti ti-file-spreadsheet me-1" />
                Import participant
              </button>
            </div>
          </div>

          <div className="card">
            <div className="card-header">
              <div className="row">
                <div className="col-md-3">
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      <i className="ti ti-search" />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search By Name/Mobile/Email"
                      value={searchParams.get("search") || ""}
                      onChange={(e) => updateFilter("search", e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              {pagination.page && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="countablepagination p-2">
                      <p>
                        Showing {(pagination.page - 1) * pagination.limit + 1}{" "}
                        to{" "}
                        {Math.min(
                          pagination.page * pagination.limit,
                          pagination.total
                        )}{" "}
                        of {pagination.total} results
                      </p>
                    </div>
                  </div>
                </div>
              )}

              <div className="table-responsive">
                <table className="table">
                  <thead className="thead-light">
                    <tr>
                      <th>S. No.</th>
                      <th>Name</th>
                      <th>Basic Details</th>
                      <th>Contact Details</th>
                      {role == "superadmin" && (
                        <>
                          <th>State</th>
                          <th>Constituency</th>
                        </>
                      )}

                      <th>Created At</th>
                      {/* <th>Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {items.length > 0 ? (
                      items.map((item, index) => (
                        <tr key={item._id}>
                          <td>
                            {((searchParams.get("page") ?? "1") - 1) *
                              (searchParams.get("limit") ?? "50") +
                              index +
                              1}
                            .{" "}
                          </td>
                          <td>{item.name}</td>
                          <td>
                            {item.gender} <br /> {formatDateOnly(item.dob)}
                          </td>
                          <td>
                            <a
                              className="text-primary"
                              href={`mailto: ${item.email}`}
                            >
                              {item.email}
                            </a>
                            <br />
                            <a
                              className="text-info"
                              href={`tel: ${item.mobile}`}
                            >
                              +91-{item.mobile}
                            </a>
                          </td>

                          {role == "superadmin" && (
                            <>
                              <td>{item?.stateId?.state}</td>
                              <td>{item?.constituencyId?.constituency}</td>
                            </>
                          )}

                          <td>{formatDate(item.createdAt)}</td>
                          {/* <td className="action-table-data">
                            <div className="edit-delete-action">
                              <Link
                                to={item?._id ? `/coupon/edit` : "#"}
                                className="me-2 p-2"
                                state={{ id: item._id }}
                              >
                                <i className="ti ti-pencil" />
                              </Link>

                              <a
                                className="p-2"
                                href="javascript:void(0);"
                                data-bs-toggle="modal"
                                data-bs-target="#delete-modal"
                                onClick={(e) => {
                                  handleOpenDeleteModal(item._id, "coupons");
                                }}
                              >
                                <i className="ti ti-trash" />
                              </a>
                            </div>
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={7} style={{ textAlign: "center" }}>
                          No participant Registered till now
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {pagination.page && (
                  <div className="row">
                    <div className="col-md-6">
                      <div className="page-title p-2">
                        <p className="d-flex" style={{ placeItems: "center" }}>
                          Rows per page:
                          <select
                            className="searchForRows"
                            value={searchParams.get("limit") || ""}
                            onChange={(e) =>
                              updateFilter("limit", e.target.value)
                            }
                          >
                            <option value="10">10</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                          entries
                        </p>
                      </div>
                    </div>

                    <Pagination
                      pagination={pagination}
                      updateFilter={updateFilter}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="standard-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="standard-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="standard-modalLabel">
                Import Participants
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div>
                <div
                  id="statusAlert"
                  className="alert status-alert d-none"
                  role="alert"
                >
                  <div className="d-flex align-items-center">
                    <i id="statusIcon" className="me-2" />
                    <span id="statusMessage" />
                  </div>
                </div>
                <div className="mb-4">
                  <h5 className="fw-semibold mb-3">
                    <i className="bi bi-download me-2" />
                    Download Sample File
                  </h5>
                  <p className="text-muted small mb-3">
                    Download a sample CSV file to understand the required format
                    for your data import.
                  </p>
                  <button
                    id="downloadBtn"
                    className="btn btn-success w-100 py-2"
                  >
                    <i className="bi bi-download me-2" />
                    Download Sample CSV
                  </button>
                </div>
                <hr className="my-4" />
                <h5 className="fw-semibold mb-3">
                  <i className="bi bi-cloud-upload me-2" />
                  Upload Your File
                </h5>
                {/* Upload Zone */}
                <div
                  id="uploadZone"
                  className="border mb-4 upload-zone p-4 text-center"
                >
                  <i className="bi bi-cloud-upload display-1 text-muted mb-3" />
                  <h6 className="fw-semibold text-dark mb-2">
                    Drag &amp; drop your file
                  </h6>
                  <p className="text-muted small mb-3">
                    or{" "}
                    <span className="text-primary fw-semibold">
                      click to browse
                    </span>
                  </p>
                  <small className="text-muted">
                    Supports: CSV, TXT files (Max 5MB)
                  </small>
                </div>
                <input
                  type="file"
                  id="fileInput"
                  accept=".csv,.txt"
                  style={{ display: "none" }}
                />
                {/* File Preview */}
                <div id="filePreview" className="mb-4 d-none">
                  <h6 className="fw-semibold mb-3">
                    <i className="bi bi-file-text me-2" />
                    Uploaded File
                  </h6>
                  <div className="file-preview p-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center">
                        <i className="bi bi-file-earmark-text text-primary fs-3 me-3" />
                        <div>
                          <div id="fileName" className="fw-semibold" />
                          <small id="fileSize" className="text-muted" />
                        </div>
                      </div>
                      <button
                        id="removeFileBtn"
                        className="btn btn-sm btn-outline-danger"
                      >
                        <i className="bi bi-trash" />
                      </button>
                    </div>
                  </div>
                </div>
                {/* File Format Info */}
                <div className="bg-soft-info p-3 mb-4">
                  <h6 className="fw-semibold text-primary mb-2">
                    <i className="bi bi-info-circle me-2" />
                    File Format Requirements
                  </h6>
                  <ul className="small text-muted mb-0 ps-3">
                    <li>First row should contain column headers</li>
                    <li>Use comma (,) as delimiter</li>
                    <li>Ensure proper data formatting</li>
                    <li>Remove any special characters</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Update Data
              </button>
            </div>
          </div>{" "}
          {/* end modal content */}
        </div>{" "}
        {/* end modal dialog */}
      </div>
    </>
  );
}

export default List;
